"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgeVerificationProviderResultSchema = exports.AgeVerificationProviderRequestSchema = exports.AgeVerificationAddressSchema = exports.AgeVerificationProviderIdSchema = void 0;
const zod_1 = require("zod");
exports.AgeVerificationProviderIdSchema = zod_1.z.enum(['veratad', 'bluecheck', 'persona', 'stripe_identity']);
exports.AgeVerificationAddressSchema = zod_1.z.object({
    street: zod_1.z.string(), city: zod_1.z.string(), state: zod_1.z.string().length(2), zip: zod_1.z.string(),
});
exports.AgeVerificationProviderRequestSchema = zod_1.z.object({
    fullName: zod_1.z.string().min(1),
    dob: zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    address: exports.AgeVerificationAddressSchema.optional(),
    minimumAge: zod_1.z.number().int().min(0).max(120),
    // present only on a document/biometric escalation
    idImageFrontS3Key: zod_1.z.string().optional(),
    idImageBackS3Key: zod_1.z.string().optional(),
    selfieS3Key: zod_1.z.string().optional(),
});
exports.AgeVerificationProviderResultSchema = zod_1.z.object({
    status: zod_1.z.enum(['passed', 'failed', 'manual_review']),
    confidence: zod_1.z.number().min(0).max(1).optional(),
    checksRun: zod_1.z.array(zod_1.z.string()).default([]),
    verifiedAge: zod_1.z.number().int().optional(),
    reason: zod_1.z.string().optional(),
    providerRefId: zod_1.z.string().optional(),
});
//# sourceMappingURL=age-verification.schema.js.map